<template>
  <v-runtime-template
    v-if="isContentVisible"
    :template="htmlTemplateToParse"
    class="text-and-widget-display"
  />
</template>

<script>
// https://www.npmjs.com/package/vue3-runtime-template
import VRuntimeTemplate from 'vue3-runtime-template'
import WidgetParser from '@shared/components/widget-parser/WidgetParser.vue'

export default {
  name: 'TextAndWidgetDisplay',
  components: {
    VRuntimeTemplate,
    // használva van runtime!!
    // eslint-disable-next-line vue/no-unused-components
    WidgetParser,
  },
  props: {
    /**
     * cikk tartalma
     */
    textBody: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /**
       * widget keresésére szolgáló regex pattern
       *
       * azért kellett, hogy tudjuk használni olyan widgetre is aminek nincsenek paraméterei,
       * ezeket eddig nem fogta meg, de mostmár a paraméterei a widgetnek opcionálisak
       * pl paramosra: {{youtube:id=dQw4w9WgXcQ;}}
       * pl param nélkülire: {{valami_widget}}
       */
      widgetRegex: /\{\{(?<widget>.*?)\}\}/gi,
      /**
       * cikk törzs látható-e
       */
      isContentVisible: true,
    }
  },
  computed: {
    /**
     * widgetektől megtisztitott szöveg, amik közé be le illesztve a widget
     */
    htmlTemplateToParse() {
      if (this.textBody === null) {
        return ''
      }
      // Regex: a linkeket amiben szerepel window.location.host azokat ismerje fel,
      // hogy a későbbiekben ezt le cseréljül egy sima '/' -re mivel router link to attribútum lesz belőle
      // de ha https://www.gyerefutni.com akkor nem bántjuk, marad https://www.gyerefutni.com
      const ownHostRegex = new RegExp('http.?://' + window.location.host + '/', 'gi')

      // TODO: nem fog kelleni, ha valóban nem a link felépitéssel van a gond
      // // ckeditor nem valid html formát készit a félkövér és dőlt linkről, ezért pontosítani kell az eredményen.
      // // input: <a href="https://cegeshelyszinek.hu" target="_blank"><i><strong>cegeshelyszinek</strong></i></a>
      // // output: <i><strong><a href="https://cegeshelyszinek.hu" target="_blank">cegeshelyszinek</a></strong></i>
      // // Az garantált, hogy ha van i és strong tag is akkor az i tag előbb van sorrendben.
      // // const boldLinkRegex = new RegExp('(<a[^>]*>)(<i[^>]*>)?(<strong[^>]*>)?([^<]*)(<\\/strong>)?(<\\/i>)?(<\\/a>)', 'g')
      // const boldLinkRegex = /(<a[^>]*>)(<i[^>]*>)?(<strong[^>]*>)?([^<]*)(<\/strong>)?(<\/i>)?(<\/a>)/g
      // const textPartsToStyledLink = this.textBody.replace(boldLinkRegex, function (match, p1, p2, p3, p4, p5, p6, p7) {
      //   // Az elágazások alapján döntjük el, melyik taget hagyjuk meg, és hogyan cseréljük ki
      //   if (p2 && p3) {
      //     // amikor mind a kettő szerepel:
      //     // input: <a href="https://cegeshelyszinek.hu" target="_blank"><i><strong>cegeshelyszinek</strong></i></a>
      //     // output: <i><strong><a href="https://cegeshelyszinek.hu" target="_blank">cegeshelyszinek</a></strong></i>
      //     return p2 + p3 + p1 + p4 + p7 + p5 + p6
      //   } else if (p3) {
      //     // amikor csak a <strong> szerepel:
      //     // input: <a href="https://cegeshelyszinek.hu" target="_blank"><strong>cegeshelyszinek</strong></a>
      //     // output: <strong><a href="https://cegeshelyszinek.hu" target="_blank">cegeshelyszinek</a></strong>
      //     return p3 + p1 + p4 + p7 + p5
      //   } else if (p2) {
      //     // amikor csak a <i> szerepel:
      //     // input: <a href="https://cegeshelyszinek.hu" target="_blank"><i>cegeshelyszinek</i></a>
      //     // output: <i><a href="https://cegeshelyszinek.hu" target="_blank">cegeshelyszinek</a></i>
      //     return p2 + p1 + p4 + p7 + p6
      //   }
      //   // Ha nincs <i> vagy <strong>, akkor nem cserélünk
      //   return match
      // })

      // példa: 'Az <a href="https://www.pp-ucka.hr/en/">Učka Nature Park</a> &nbsp;meglátogatása után a <a href="https://www.visitopatija.com/hu/rumac-family-farming-estate-p1975">Family Farming Estate Rumac</a> jóvoltából egy csodálatos helyi ital és ételkülönlegességeket bemutató kóstolóprogramon vettünk részt. &nbsp;A <a href="/helyszin/vital-hotel-nautis">Hotel Ambasador</a> opatijai szálloda meleg fogadtatása után bejártuk a szállodalánc többi tagját is,<br>'
      // ebből: 'Az <a href="https://www.pp-ucka.hr/en/">Učka Nature Park</a> &nbsp;meglátogatása után a <a href="https://www.visitopatija.com/hu/rumac-family-farming-estate-p1975">Family Farming Estate Rumac</a> jóvoltából egy csodálatos helyi ital és ételkülönlegességeket bemutató kóstolóprogramon vettünk részt. &nbsp;A <router-link to="/helyszin/vital-hotel-nautis">Hotel Ambasador</router-link> opatijai szálloda meleg fogadtatása után bejártuk a szállodalánc többi tagját is,<br>'

      // elválasztjuk a szövegtől a widgeteket, a relatív linkekek pedig router-linkre cseréljük
      const textParts = this.textBody
        .replace(this.widgetRegex, 'widgetName')
        .replace(ownHostRegex, '/')
        // .replace(boldLinkRegex, textPartsToStyledLink)
        // az olyan linkeket amiben a href="#..." azokat speciálisan kezeljük scrollToBlock() methoddal
        .replace(/<a(?<linkAttributes1>.*?)href="#(?<href>[^"]+)"(?<linkAttributes2>.*?)>(?<linkText>.*?)<\/a>/gi,
          '<a$<linkAttributes1>href="#$<href>"$<linkAttributes2> @click="scrollToBlock($event, \'$<href>\')">$<linkText></a>')
        // belső linkekből router-link létrehozása. A külső linkek maradjanak <a> tag.
        // a külső linkekben van ":" a belsőkben nincs.
        // feltételezzük az oldalon belüli linkekben nincs '.' tehát amiben van, az file, és nem kell router link.
        .replace(/<a(?<linkAttributes1>[^>]+?)href="(?<href>[^.:"]+?)"(?<linkAttributes2>.*?)>(?<linkText>[^<]+)<\/a>/gi,
          '<router-link$<linkAttributes1>to="$<href>"$<linkAttributes2>>$<linkText></router-link>')
        .split('widgetName')

      // összeállítjuk a renderelendő html-t a widget parserrel benne, illetve az egészet egy divbe wrapeljük
      // mert egy root element lehet a runtime compilernek átadva, a <template> itt nem használható
      let templateToParse = '<div>'
      textParts.forEach((text, index) => {
        templateToParse += text
        // ha van ide tartozó widget
        if (this.widgetDataList[index]) {
          // this.widgetDataList[index].widgetData azért van JSON.stringify-olva, mert egyébként a templateben [Object object] lenne,
          // és a " karaktereket a JSON.stringify után ki kell cserérni sima '-okra.
          templateToParse += '<widget-parser :widget-name="\'' + this.widgetDataList[index].widgetName + '\'" :widget-data="' +
            JSON.stringify(this.widgetDataList[index].widgetData).replace(/"/gi, '\'') + '" />'
        }
      })
      templateToParse += '</div>'

      return templateToParse
    },
    /**
     * widget paraméter adatokat tárolo lista
     */
    widgetDataList() {
      const matches = this.textBody.matchAll(this.widgetRegex)
      const widgetDataList = []
      for (const match of matches) {
        const widgetData = {}
        const widgetSplit = match.groups.widget.split(':')
        const widgetName = widgetSplit[0]
        if (widgetSplit[1] !== undefined) {
          const tempWidgetData = widgetSplit[1]
          tempWidgetData.split(';').forEach(dataRow => {
            if (dataRow !== '') {
              widgetData[dataRow.split('=')[0]] = dataRow.split('=')[1]
            }
          })
        }
        widgetDataList.push({
          widgetName: widgetName,
          widgetData: widgetData,
        })
      }
      return widgetDataList
    },
  },
  watch: {
    /**
     * ez azért kell, mert a runtime compiler nem figyeli a template változást,
     * ezért el kell tüntessük, majd render után újra meg kell jelenítenünk
     */
    textBody: {
      handler() {
        this.isContentVisible = false
        this.$nextTick(() => {
          this.isContentVisible = true
        })
      },
    },
  },
  methods: {
    /**
     * # href-es linkek esetén
     * (pl: <a href=#mennyifeh>Mennyi fehérjét szedjek?</a>)
     * végzi el az odascrollozást
     *
     * NOTE: eredetileg id-re kellene mutasson, gyakorlatilag a cikkekben name attributumba írjűk be, ezért azt is nézzük,
     * ha azt nem találjuk akkor megnézzük id-re is.
     *
     * @param { PointerEvent } event
     * @param { String } blockName
     */
    scrollToBlock(event, blockName) {
      event.preventDefault()
      const blocksByName = document.getElementsByName(blockName)
      const blockById = document.getElementById(blockName)
      if (blocksByName && blocksByName[0]) {
        blocksByName[0].scrollIntoView()
      } else if (blockById !== null) {
        blockById.scrollIntoView()
      }
    },
  },
}
</script>

<style lang="scss">
// nem lehet scoped mert nem hatna a compiler által generált tartalomra, de classon belül tartjuk
.text-and-widget-display {
  img {
    max-width: 100%;
    height: auto;
  }

  // ckeditor által használt beállítások. Szükségesek a kép pozicionáláshoz.
  & .image-style-block-align-left,
  & .image-style-block-align-right {
    max-width: calc(100% - var(--ck-image-style-spacing));
  }

  /* Allows displaying multiple floating images in the same line.
  See https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */
  & .image-style-align-left,
  & .image-style-align-right {
    clear: none;
  }

  & .image-style-side {
    float: right;
    margin-left: var(--ck-image-style-spacing);
    max-width: 50%;
  }

  & .image-style-align-left {
    float: left;
    margin-right: var(--ck-image-style-spacing);
  }

  & .image-style-align-center {
    margin-left: auto;
    margin-right: auto;
  }

  & .image-style-align-right {
    float: right;
    margin-left: var(--ck-image-style-spacing);
  }

  & .image-style-block-align-right {
    margin-right: 0;
    margin-left: auto;
  }

  & .image-style-block-align-left {
    margin-left: 0;
    margin-right: auto;
  }

  /* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */
  & p + .image-style-align-left,
  & p + .image-style-align-right,
  & p + .image-style-side {
    margin-top: 0;
  }

  & .image-inline {
    &.image-style-align-left,
    &.image-style-align-right {
      margin-top: var(--ck-inline-image-style-spacing);
      margin-bottom: var(--ck-inline-image-style-spacing);
    }

    &.image-style-align-left {
      margin-right: var(--ck-inline-image-style-spacing);
    }

    &.image-style-align-right {
      margin-left: var(--ck-inline-image-style-spacing);
    }
  }
}
</style>
